import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const AUTH_KEY = "li_auth";

export function getAuth() {
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || "null");
  } catch {
    return null;
  }
}

export function setAuth(v) {
  if (!v) localStorage.removeItem(AUTH_KEY);
  else localStorage.setItem(AUTH_KEY, JSON.stringify(v));
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const auth = getAuth();
  if (auth?.token) cfg.headers.Authorization = `Bearer ${auth.token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setAuth(null);
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function pdfUrl(sid) {
  const auth = getAuth();
  return `${API}/certificates/${sid}/pdf?token=${encodeURIComponent(auth?.token || "")}`;
}

export function excelUrl() {
  const auth = getAuth();
  return `${API}/export/excel?token=${encodeURIComponent(auth?.token || "")}`;
}
